import { CustomColumnProps } from '../components/custom/CustomTable';

export function buildExportColumnPreferences(columns: CustomColumnProps[]): string[] {
  return columns
    .filter((column) => !column.hidden && column.field)
    .map((column) => {
      const key = (column.columnKey || column.sortField || column.field)!;
      if (key === 'detection' || column.field === 'detection') {
        return 'rule';
      }
      return key;
    });
}
